import { message } from "antd";

const GLOBAL_TOAST_STATUSES = new Set([401, 403]);

export const getReportErrorMessage = (error, fallback = "Something went wrong. Please try again.") => {
  const errMsg = error?.response?.data?.message;
  if (typeof errMsg === "string" && errMsg.trim()) return errMsg;
  if (typeof errMsg?.message === "string" && errMsg.message.trim()) {
    return errMsg.message;
  }
  return fallback;
};

/**
 * Shows a single error toast for report-builder flows.
 * Skips 401/403 because HELPERS.request already toasts those once.
 */
export const showReportError = (error, fallback) => {
  if (GLOBAL_TOAST_STATUSES.has(error?.response?.status)) return;
  message.error(getReportErrorMessage(error, fallback));
};
